module.exports = __webpack_public_path__ + "public/images/adfox-close.ca0e08cddc79be291424b4e1db53c577.png";